export default __webpack_public_path__ + "assets/images/gzao-gyra859c869912762c6b3ef3c1af3535bc97.png";